
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";

@Component({})
export default class SsoUserPicker extends Mixins(SimpleInputMixin) {
  @Prop({ type: Array }) rules!: ((v: any) => boolean | string)[];

  isLoading = false;
  items: any[] = [];
  search = "";
  timeoutId: number | undefined;

  @Watch("search")
  onSearchChange(newSearch: string, oldSearch: string) {
    if (newSearch !== oldSearch) {
      this.searchItems();
    }
  }

  async searchItems() {
    clearTimeout(this.timeoutId);
    this.timeoutId = window.setTimeout(async () => {
      if (!this.search || !this.isValidEmail(this.search)) {
        this.items = [];
        return;
      }
      this.isLoading = true;
      try {
        const normalizedInput = this.normalizeEmail(this.search);
        const encodedEmail = encodeURIComponent(normalizedInput);
        
        const res = await this.$http.get(
            this.$store.state.ssoUri + "api/search-user?email=" + encodedEmail
        );

        this.handleApiResponse(res);

      } catch (e) {
        console.error("API Hatası:", e);
        this.handleApiError();
      } finally {
        this.isLoading = false;
      }
    }, 500);
  }

  handleApiResponse(response: any) {
    let data = response;
    
    if (data.data && typeof data.data === 'object') {
      data = data.data;
    }
    
    const { status, user } = data;
    const normalizedSearch = this.normalizeEmail(this.search);
    
    switch (status) {
      case "registered":
        if (user) {
          this.items = [{
            id: user.id,
            status: "registered",
            name: user.name || user.first_name || "",
            last_name: user.last_name || "",
            mail: this.normalizeEmail(user.email || normalizedSearch),
            confirmed: user.confirmed
          }];
        } else {
          console.error("Registered user data is missing");
          this.handleApiError();
        }
        break;
      case "incomplete_registration":
        if (user) {
          this.items = [{
            id: user.id,
            status: "incomplete_registration",
            name: user.name || user.first_name || "",
            last_name: user.last_name || "",
            mail: this.normalizeEmail(user.email || normalizedSearch),
          }];
        } else {
          console.error("Incomplete registration user data is missing");
          this.handleApiError();
        }
        break;
      case "not_found":
        this.items = [{
          id: null,
          status: "not_found",
          name: "Kayıtlı Değil",
          last_name: "",
          mail: normalizedSearch
        }];
        break;
      default:
        console.warn("Bilinmeyen yanıt durumu:", status);
        this.handleApiError();
    }
  }

  handleApiError() {
    const normalizedSearch = this.normalizeEmail(this.search);
    this.items = [{
      id: null,
      status: "error",
      name: "Hata Oluştu",
      last_name: "",
      mail: normalizedSearch
    }];
    this.$toast.error("Kullanıcı arama sırasında bir hata oluştu.");
  }

  normalizeEmail(email: string): string {
    if (!email) return '';
    return email.toLocaleLowerCase('tr-TR').trim();
  }

  userInput() {
    if (!this.localValue || typeof this.localValue !== 'object') {
      this.emitValue(null);
      this.emitUserData(this.search ? this.normalizeEmail(this.search) : "", null, "not_found", true);
      return;
    }

    const selectedItem = this.localValue as any;
    this.emitValue(selectedItem.id);

    switch (selectedItem.status) {
      case "not_found":
        this.emitUserData(this.normalizeEmail(selectedItem.mail), null, "not_found", true);
        this.$emit("sendRegistrationMail", true);
        break;

      case "incomplete_registration":
        this.emitUserData(this.normalizeEmail(selectedItem.mail), selectedItem.id, "incomplete_registration", false);
        break;

      case "registered":
        this.emitUserData(this.normalizeEmail(selectedItem.mail), selectedItem.id, "registered", false);
        if (!selectedItem.confirmed) {
          this.$emit("emailNotConfirmed", true);
        } else {
          this.$emit("sendActivationMail", true);
        }
        break;

      default:
        this.emitUserData(this.search ? this.normalizeEmail(this.search) : "", null, "not_found", true);
        break;
    }
  }

  emitValue(id: number | null) {
    this.$emit('input', id);
  }

  emitUserData(email: string, ssoUserId: number | null, status: string, isNonSSOUser: boolean) {
    if (status !== "incomplete_registration" && !email) {
      console.error("Invalid email in emitUserData");
      return;
    }
    
    const normalizedEmail = this.normalizeEmail(email);

    if (status !== "incomplete_registration") {
      this.$emit("email", normalizedEmail);
    }
    this.$emit("ssouserid", ssoUserId);
    this.$emit("userStatus", status);
    this.$emit("nonSSOUserSelected", isNonSSOUser);
  }

  getItemValue(item: any) {
    return item.id !== null ? item.id : item.mail;
  }

  isValidEmail(email: string): boolean {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(this.normalizeEmail(email));
  }
}
